/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SharedserviceMelcoModelsCreateDesignCollection,
    SharedserviceMelcoModelsCreateDesignCollectionFromJSON,
    SharedserviceMelcoModelsCreateDesignCollectionToJSON,
    SharedserviceMelcoModelsDesignCollection,
    SharedserviceMelcoModelsDesignCollectionFromJSON,
    SharedserviceMelcoModelsDesignCollectionToJSON,
    SharedserviceMelcoModelsDesignReferences,
    SharedserviceMelcoModelsDesignReferencesFromJSON,
    SharedserviceMelcoModelsDesignReferencesToJSON,
    SharedserviceMelcoModelsError,
    SharedserviceMelcoModelsErrorFromJSON,
    SharedserviceMelcoModelsErrorToJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection,
    SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollectionFromJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollectionToJSON,
    SharedserviceMelcoModelsUpdateDesignCollection,
    SharedserviceMelcoModelsUpdateDesignCollectionFromJSON,
    SharedserviceMelcoModelsUpdateDesignCollectionToJSON,
} from '../models';

export interface DesignCollectionsApiDesignCollectionsReferencesRequest {
    id: string;
}

export interface DesignCollectionsApiUserDesignCollectionUpdateRequest {
    id: string;
    sharedserviceMelcoModelsUpdateDesignCollection?: SharedserviceMelcoModelsUpdateDesignCollection;
}

export interface DesignCollectionsApiUserDesignCollectionsCreateRequest {
    sharedserviceMelcoModelsCreateDesignCollection?: SharedserviceMelcoModelsCreateDesignCollection;
}

export interface DesignCollectionsApiUserDesignCollectionsDeleteRequest {
    id: string;
    force?: boolean;
}

export interface DesignCollectionsApiUserDesignCollectionsDuplicateRequest {
    id: string;
}

export interface DesignCollectionsApiUserDesignCollectionsGetDefRequest {
    id: string;
    publishState?: string;
}

export interface DesignCollectionsApiUserDesignCollectionsGetListRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    publishState?: string;
}

/**
 * 
 */
export class DesignCollectionsApi extends runtime.BaseAPI {

    /**
     */
    async designCollectionsReferencesRaw(requestParameters: DesignCollectionsApiDesignCollectionsReferencesRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignReferences>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling designCollectionsReferences.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/collections/{Id}/references`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignReferencesFromJSON(jsonValue));
    }

    /**
     */
    async designCollectionsReferences(requestParameters: DesignCollectionsApiDesignCollectionsReferencesRequest): Promise<SharedserviceMelcoModelsDesignReferences> {
        const response = await this.designCollectionsReferencesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignCollectionUpdateRaw(requestParameters: DesignCollectionsApiUserDesignCollectionUpdateRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignCollectionUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/designs/collections/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoModelsUpdateDesignCollectionToJSON(requestParameters.sharedserviceMelcoModelsUpdateDesignCollection),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userDesignCollectionUpdate(requestParameters: DesignCollectionsApiUserDesignCollectionUpdateRequest): Promise<SharedserviceMelcoModelsDesignCollection> {
        const response = await this.userDesignCollectionUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignCollectionsCreateRaw(requestParameters: DesignCollectionsApiUserDesignCollectionsCreateRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignCollection>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/designs/collections`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoModelsCreateDesignCollectionToJSON(requestParameters.sharedserviceMelcoModelsCreateDesignCollection),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userDesignCollectionsCreate(requestParameters: DesignCollectionsApiUserDesignCollectionsCreateRequest): Promise<SharedserviceMelcoModelsDesignCollection> {
        const response = await this.userDesignCollectionsCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignCollectionsDeleteRaw(requestParameters: DesignCollectionsApiUserDesignCollectionsDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignCollectionsDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['Force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/collections/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userDesignCollectionsDelete(requestParameters: DesignCollectionsApiUserDesignCollectionsDeleteRequest): Promise<void> {
        await this.userDesignCollectionsDeleteRaw(requestParameters);
    }

    /**
     */
    async userDesignCollectionsDuplicateRaw(requestParameters: DesignCollectionsApiUserDesignCollectionsDuplicateRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignCollectionsDuplicate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/collections/{Id}/duplicate`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userDesignCollectionsDuplicate(requestParameters: DesignCollectionsApiUserDesignCollectionsDuplicateRequest): Promise<SharedserviceMelcoModelsDesignCollection> {
        const response = await this.userDesignCollectionsDuplicateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignCollectionsGetDefRaw(requestParameters: DesignCollectionsApiUserDesignCollectionsGetDefRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignCollectionsGetDef.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/collections/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userDesignCollectionsGetDef(requestParameters: DesignCollectionsApiUserDesignCollectionsGetDefRequest): Promise<SharedserviceMelcoModelsDesignCollection> {
        const response = await this.userDesignCollectionsGetDefRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignCollectionsGetListRaw(requestParameters: DesignCollectionsApiUserDesignCollectionsGetListRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/collections`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userDesignCollectionsGetList(requestParameters: DesignCollectionsApiUserDesignCollectionsGetListRequest): Promise<SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection> {
        const response = await this.userDesignCollectionsGetListRaw(requestParameters);
        return await response.value();
    }

}
